import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';

type ContribCountResponse = {
  snapshot: string;
  activeContributorCountLast90days: number;
  activeContributorCountLast365days: number;
};

function fetchContributorSnapshot() {
  return get<ContribCountResponse>('/api/contributors/latest-snapshot-count');
}

export const getContributorSnapshotQueryKey = (): QueryKey => ['contributors', 'snapshot'];

/**
 * Hook to fetch the latest contributor count snapshot.
 * Snapshots are generated every Sunday morning.
 * @returns Query result containing contributor counts for 90 and 365 day periods
 */
export const useContributorSnapshot = () => {
  return useQuery<ContribCountResponse>({
    queryKey: getContributorSnapshotQueryKey(),
    queryFn: fetchContributorSnapshot,
    staleTime: 600_000, // Cache for 10 minutes (snapshot updates weekly, we dont need super live data)
  });
};
